import validate from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/pages/runtime/validate.js";
import profile_45complete_45global from "/root/code-vivasport/vs2-front/middleware/profile-complete.global.ts";
import manifest_45route_45rule from "/root/code-vivasport/vs2-front/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  profile_45complete_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}